export const auctionDetailsItemStyle = {
	wrapper: {
		marginTop: '40px',
		height: '100%',
	},

	content: {
		maxWidth: '432px',
		width: '100%',
		display: 'flex',
		flexWrap: 'wrap',
		gap: '8px',
		position: 'relative',
	},

	altContent: {
		maxWidth: '432px',
		hight: '432px',
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: '8px',
		position: 'relative',
		background: 'var(--neutral-100)',

		svg: {
			height: '60px',
			width: '60px',
			path: {
				fill: 'var(--neutral-200)',
			},
		},
	},

	logosWrapper: {
		display: 'flex',
		gap: '24px',
		marginBottom: '24px',
	},

	donorLogo: {
		maxWidth: '432px',
		height: '257px',
		width: '100%',

		'& img': {
			height: '100%',
			width: '100%',
			objectFit: 'cover',
		},

		'&:not(:first-of-type)': {
			maxWidth: '80px',
			height: '80px',
		},
	},

	title: {
		marginBottom: '16px',
	},

	category: {
		color: 'var(--neutral-300)',
	},

	valuesWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
		marginBottom: '20px',
	},

	valuesTitles: {
		display: 'flex',
		'& p': {fontWeight: 400},
	},

	valuesTitle: {
		marginRight: '4px',
		color: 'var(--neutral-300)',
	},

	winnerWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
	},

	description: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		marginBottom: '24px',
	},

	donorsWrapper: {
		marginBottom: '24px',
	},

	descriptionText: {
		wordBreak: 'break-word',
		overflowWrap: 'anywhere',
		whiteSpace: 'pre-line',
	},
};
